import { render } from "./DataDisplay.vue?vue&type=template&id=0c283201&scoped=true"
import script from "./DataDisplay.vue?vue&type=script&lang=js"
export * from "./DataDisplay.vue?vue&type=script&lang=js"

import "./DataDisplay.vue?vue&type=style&index=0&id=0c283201&lang=css"
import "./DataDisplay.vue?vue&type=style&index=1&id=0c283201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c283201"]])

export default __exports__